import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import LocalCookie, { CookieKey } from "util/LocalCookie";
import {
  LanguageTypeMap,
  LanguageHeaderMap,
  KYC_FAIL_CODES,
} from "constants/vars";
import message from "components/common/BitMessage";
import { openGlobalKYCDialog } from "util/Common";
import { captureResponseException } from "util/sentry/captureResponseException";
import { captureBusinessException } from "util/sentry/captureBusinessException";
import { checkIsApp } from "util/DeviceInfo";
import { createAppRequest } from "util/jsbridge/request";
import { throttle } from "lodash-es";
import { EventCenter, EventKeys } from "util/EventControl";
import getTerminalCode from "util/DeviceInfo/terminalCode";
import getFingerprint from "util/DeviceInfo/fingerPrint";
import {
  ApiResDataReplaceFastestImageDomainFn,
  // bitSignVerify,
  // getTraceId,
  // getSimulationTradeFlag,
  // deleteSimulationTradeFlag,
  // getSimulationTradeHeader
} from "@saas2/utils";
import { isBrowserEnv } from "@app/utils/constants";
// import { checkIsApp } from '@bit/js-bridge'
import { openKyc } from "util/jsbridge";
import noHeaderApiList from "./simulation/noHeaderApiList";
import Cookies from "js-cookie";
import timeManager from "util/SaasUtils/ServerTimeManager";

const SLASH = "/";

const USERINFOAPI = "user/overview/userinfo";

let instance = axios.create({
  timeout: 20000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});
const baseInstance = createInstance("");

function logoutRequest() {
  EventCenter.emit(EventKeys.CLEAR_USER_INFO);

  return baseInstance.post("v1/user/public/clearCookie");
}

const throttledLogoutRequest = throttle(logoutRequest, 400);

// 这里的拦截主要是处理全局的网络请求错误
instance.interceptors.request.use(
  async (config) => {
    const { url, data } = config || {};
    const locale = LocalCookie.get(CookieKey.LANG) || "en";
    const isSimulationTrade = false;
    // const isSimulationTrade = getSimulationTradeFlag()
    // const simulationTradeHeader = getSimulationTradeHeader()
    config.headers["website"] = "mix";
    config.headers["terminaltype"] = 1;
    // 顶象正常token
    // config.headers["dy-token"] = dxToken.getDyToken();
    if (process.env.REACT_APP_ENV === "beta") {
      config.headers["beta"] = "beta";
    }
    config.headers["locale"] = LanguageHeaderMap[locale];
    config.headers["language"] = LanguageHeaderMap[locale];
    config.headers["terminalCode"] = getTerminalCode();
    config.headers["deviceId"] = getFingerprint();
    // config.headers["uhti"] = getTraceId(); // traceId
    config.headers["tm"] = timeManager.getTime(); // 时间戳

    /**
     * 模拟盘交易标识
     */
    if (
      isSimulationTrade &&
      !noHeaderApiList.some((api) => url.startsWith(api))
    ) {
      // config.headers['paptrading'] = simulationTradeHeader.paptrading
    }

    // // 核心接口验签，初始化
    // await bitSignVerify.init({
    //   debug: false,
    //   captureBusinessException,
    //   errorToast: (msg: string) => {
    //     message.error(msg);
    //   },
    //   logout: () => {
    //     throttledLogoutRequest();
    //   },
    // });

    // // 核心接口验签，拦截登录url
    // config.data = await bitSignVerify.requestInterceptLoginUrl(url, data);
    // // 核心接口验签，拦截核心url
    // const headers = await bitSignVerify.requestInterceptCoreUrl(
    //   url,
    //   data,
    //   config.headers
    // );

    // if (headers) {
    //   Object.keys(headers).forEach((key) => {
    //     if (headers[key]) config.headers[key] = headers[key];
    //   });
    // }

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

/**
 * report unexpected business code to Sentry platform
 */
export const reportUnexpectedBusinessCode = (response: AxiosResponse) => {
  const { data, config } = response;
  const responseCodeList = [
    /** response successfully  */
    "200",
    "00000",

    /** user is not login */
    "00004",
    "00005",
    "00006",

    /** TODO: describe specific meanings */
    "20906",
    "20205",
  ].concat(KYC_FAIL_CODES);

  if (!responseCodeList.includes(data?.code)) {
    const extra = {
      url: config?.url,
      params:
        config?.method?.toUpperCase() === "POST"
          ? config?.data
          : config?.params,
      res: data,
      httpCode: data?.code,
    };

    captureResponseException(
      `Business code: ${data?.code}, message: ${data?.msg}`,
      {
        extra,
        level: "fatal",
      }
    );
  }
};

/**
 * report unexpected HTTP code to Sentry platform
 */
export const reportUnexpectedHTTPCode = (err: AxiosError) => {
  const { response } = err;
  const extra = {
    url: response?.config?.url,
    params:
      response?.config?.method?.toUpperCase() === "POST"
        ? response?.config?.data
        : response?.config?.params,
    res: {
      code: response?.status,
      msg: err?.message,
    },
    httpCode: String(response?.status),
  };

  captureResponseException(
    `HTTP code: ${response?.status}, message: ${err?.message}`,
    {
      extra,
      level: "fatal",
    }
  );
};

instance.interceptors.response.use(
  async (response) => {
    reportUnexpectedBusinessCode(response);

    // 请求成功 业务状态码错误
    if (
      response.status &&
      response.status === 200 &&
      response.data.status === "error" &&
      !KYC_FAIL_CODES.includes(response?.data?.code)
    ) {
      message.error(response.data.msg);
    }

    if (
      response.status &&
      response.status === 200 &&
      (response.data.code === "00004" ||
        response.data.code === "00005" ||
        response.data.code === "00006" ||
        response.data.code === "20906" ||
        response.data.code === "20205")
    ) {
      // 将userinfo 接口 独立处理
      if (!response.config.url.includes(USERINFOAPI)) {
        // message.error(response.data.msg)
        //退出操作
        throttledLogoutRequest()
          .then(() => {
            if (localStorage.getItem("sk:notlogin:tip") === "1") {
              // 如果有限制登录的标识 不做处理
            }
            //  else {
            //     window.location.reload()
            // }
          })
          .catch(() => {
            // window.location.reload()
          });
      }
    }

    // 核心接口验签，拦截响应，处理验签失败错误码
    // await bitSignVerify.responseInterceptor(response.config?.url, response);

    // 全局kyc弹窗
    if (KYC_FAIL_CODES.includes(response?.data?.code)) {
      // 这里替换成jsBridge的方法
      if (checkIsApp()) {
        // 这里暂时不替换jsbridge的方法，还是用原来的方法
        openKyc();
      } else {
        openGlobalKYCDialog(response.data.code).then(() => {});
      }
      return Promise.reject(response);
    } else {
      return response;
    }
  },
  (err) => {
    reportUnexpectedHTTPCode(err);

    // 预留处理网络请求错误的地方
    // 注意：有可能出现非http状态码的错误，比如超时等
    // switch (err?.response?.status) {
    //     case 504:
    //     case 404:
    //         // not found
    //         break
    //     case 403:
    //         // forbidden
    //         break
    //     default:
    //     // 其他各种异常
    // }
    return Promise.reject(err);
  }
);

/**
 * 创建请求实例
 * @param apiGroupName 功能组，common，user等
 * @param serviceGroup 服务组，btapi表示复用主站 api表示使用混合合约
 */
function createInstance(apiGroupName: string, serviceGroup?: string) {
  // 处理一下前缀
  let base = (serviceGroup ? `/${serviceGroup}/` : "/") + apiGroupName;

  function getFullUrl(apiName: string) {
    // 预处理完整的请求url
    let url = base + SLASH + apiName;
    url = url.replace(/\/\//g, "/");
    return url;
  }

  return {
    //获取request
    setHeaderRequestTime() {
      // 这里的拦截主要是处理全局的网络请求错误
      instance.interceptors.response.use((response) => {
        if (
          response?.config?.url === "/v1/trigger/strategy/config/regular" ||
          response?.config?.url ===
            "/v1/trigger/strategy/common/query/strategyCurrentList"
        ) {
          localStorage.setItem(
            "mix_requesttime",
            response.headers?.requesttime
          );
        }

        return response;
      });
    },

    post<T>(apiName: string, data: object = {}): Promise<T> {
      if (!apiName || apiName === "") {
        return Promise.reject("wrong api name!");
      }
      // 与业务无关的异常将在这里处理
      return new Promise<T>((resolve, reject) => {
        const axiosOptions: AxiosRequestConfig = {
          url: getFullUrl(apiName),
          method: "post",
          data: Object.assign(data, {
            languageType: LanguageTypeMap[LocalCookie.get(CookieKey.LANG)],
          }),
        };
        instance
          .request<T>(axiosOptions)
          .then((data: AxiosResponse<T>) => {
            resolve(data.data);
          })
          .catch((e) => {
            reject(e.message);
          });
      });
    },
    get<T>(apiName: string, params: object = {}): Promise<T> {
      if (!apiName || apiName === "") {
        return Promise.reject("wrong api name!");
      }
      // 与业务无关的异常将在这里处理
      return new Promise<T>((resolve, reject) => {
        const axiosOptions: AxiosRequestConfig = {
          url: getFullUrl(apiName),
          method: "get",
          data: params,
        };
        instance
          .request<T>(axiosOptions)
          .then((data: AxiosResponse<T>) => {
            resolve(data.data);
          })
          .catch((e) => {
            reject(e.message);
          });
      });
    },
    file<T>(apiName: string, data: object = {}, config): Promise<T> {
      if (!apiName || apiName === "") {
        return Promise.reject("wrong api name!");
      }
      // 与业务无关的异常将在这里处理
      return new Promise<T>((resolve, reject) => {
        const axiosOptions: AxiosRequestConfig = {
          url: getFullUrl(apiName),
          method: "post",
          data: Object.assign(data, {
            languageType: LanguageTypeMap[LocalCookie.get(CookieKey.LANG)],
          }),
          ...config,
        };
        instance
          .request<T>(axiosOptions)
          .then((data: AxiosResponse<T>) => {
            resolve(data.data);
          })
          .catch((e) => {
            reject(e.message);
          });
      });
    },
  };
}

export default createInstance;
